import React from "react";
import ContentLoader from "react-content-loader";

export default function ListLoader({title}) {
  return (
    <ContentLoader
      speed={2}
      width="100%"
      height={500}
      backgroundColor="rgb(255, 242, 231)"
      foregroundColor="#ecebeb"
    >
       <text
          x="50%"
          y="50%"
          dominantBaseline="middle"
          textAnchor="middle"
          fontSize="50"
          fill="#333"
        >
          {title}
        </text>
      <rect x="0" y="0" rx="25" ry="25" width="100%" height="140" />
      <rect x="0" y="170" rx="25" ry="25" width="100%" height="140" />
      <rect x="0" y="340" rx="25" ry="25" width="100%" height="140" />
      <rect x="0" y="510" rx="25" ry="25" width="100%" height="140" />
    </ContentLoader>
  );
}
